var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 6c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h7zm5-5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h1V3H8v1a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1h7z"}));
}

Copy.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Copy;

Copy.default = Copy;
